import PropTypes from 'prop-types';
import classnames from 'classnames/bind';
import styles from './Option.module.scss';
import { jsx as _jsx } from "react/jsx-runtime";
const cln = classnames.bind(styles);
function Option({
  children,
  onClick,
  className,
  ...rest
}) {
  const classes = cln('Option', className, {
    'Option--clickable': onClick
  });
  return /*#__PURE__*/_jsx("span", {
    className: classes,
    onClick: onClick,
    ...rest,
    children: children
  });
}
Option.propTypes = {
  /** custom class name */
  className: PropTypes.string,
  /** Click event handler */
  onClick: PropTypes.func,
  children: PropTypes.node
};
function Icon({
  children = '',
  className,
  onClick,
  padding = 4,
  ...rest
}) {
  const classes = cln('OptionIcon', className, {
    'OptionIcon--clickable': onClick
  });
  return /*#__PURE__*/_jsx("span", {
    style: {
      padding: `0 ${padding}px`
    },
    className: classes,
    onClick: onClick,
    ...rest,
    children: children
  });
}
Icon.propTypes = {
  children: PropTypes.node,
  /** custom class name */
  className: PropTypes.string,
  /** Click event handler */
  onClick: PropTypes.func,
  /** Padding of an icon */
  padding: PropTypes.number
};
function Label({
  children = '',
  className,
  ...rest
}) {
  return /*#__PURE__*/_jsx("span", {
    className: cln('OptionLabel', className),
    ...rest,
    children: children
  });
}
Label.propTypes = {
  children: PropTypes.node,
  /** custom class name */
  className: PropTypes.string
};
Option.Label = Label;
Option.Icon = Icon;
export default Option;
export { Label, Icon };